namespace app.model.project {
  export enum Status {
    Active = "active",
    Trial = "trial",
    Hibernate = "hibernate",
    Purged = "purged"
  }
}
(window as any).Status = app.model.project.Status;
